var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m20.821 7.282-5.934-.904-2.65-5.632A1.47 1.47 0 0 0 11.715.2a1.38 1.38 0 0 0-1.427 0c-.217.13-.398.319-.524.546L7.114 6.379l-5.934.903c-.255.039-.493.15-.69.324-.196.173-.343.4-.422.656-.08.255-.09.53-.028.79.061.262.191.5.375.687l4.293 4.385-1.013 6.193c-.043.264-.015.537.082.786.097.248.258.464.465.622s.453.252.71.271c.255.02.51-.036.738-.161L11 18.91l5.308 2.922a1.32 1.32 0 0 0 1.448-.11 1.43 1.43 0 0 0 .465-.622c.097-.25.125-.521.082-.786L17.29 14.12l4.296-4.382c.183-.187.313-.425.374-.686.061-.26.052-.534-.027-.79a1.45 1.45 0 0 0-.421-.655 1.35 1.35 0 0 0-.688-.324z"
  })));
};
export default SvgStar;